import './index.scss';
import React from 'react';
import Header from '../../header';
import { useComparison } from '../../provider';
import { useDocumentsView } from '../provider';
import DocSelect from './doc_select';
import DocView from './doc_view';
const DocumentsView = () => {
    const { comparisonDocuments } = useComparison();
    const { anchorBookmark, anchorDoc, comparatorBookmark, comparatorDoc, setAnchorDoc, setComparatorDoc, } = useDocumentsView();
    if (!comparisonDocuments || comparisonDocuments.length < 2)
        return null;
    return React.createElement("div", { className: 'documents-panel' },
        React.createElement(Header, null),
        React.createElement("div", { className: 'comparison-documents' },
            React.createElement("div", { className: 'document-panel-compare' },
                React.createElement(DocSelect, { document: anchorDoc !== null && anchorDoc !== void 0 ? anchorDoc : comparisonDocuments[0], documents: comparisonDocuments, setDocument: setAnchorDoc, icon: 'fas fa-star' }),
                React.createElement(DocView, { document: anchorDoc !== null && anchorDoc !== void 0 ? anchorDoc : comparisonDocuments[0], bookmarks: anchorBookmark })),
            React.createElement("div", { className: 'document-panel-compare' },
                React.createElement(DocSelect, { document: comparatorDoc !== null && comparatorDoc !== void 0 ? comparatorDoc : comparisonDocuments[1], documents: comparisonDocuments, setDocument: setComparatorDoc, icon: 'fas fa-file' }),
                React.createElement(DocView, { document: comparatorDoc !== null && comparatorDoc !== void 0 ? comparatorDoc : comparisonDocuments[1], bookmarks: comparatorBookmark }))));
};
export default DocumentsView;
